import type { TimeInRangeInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import { useMemo } from "react"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { useThisMinute } from "src/hooks"
import { round } from "src/utils"

export function TimeInRange(props: TileProps<TimeInRangeInsight>) {
  const {
    insightKey,
    range,
  } = props

  const thisMinute = useThisMinute()
  const polyglot = usePolyglot()
  const { timeInRangeCalculation } = useCalculationsContext()

  const value = useMemo(
    () => timeInRangeCalculation === null || timeInRangeCalculation === undefined
      ? 0
      : dayjs(thisMinute).diff(
        timeInRangeCalculation,
        "minute",
        true,
      ),
    [
      timeInRangeCalculation,
      thisMinute,
    ],
  )

  const unit = value >= 59.5
    ? polyglot.t(
      "time.hours",
      round(
        value / 60,
        1,
      ),
    )
    : polyglot.t(
      "time.minute_unit",
      round(value),
    )

  // show placeholder if undefined
  const valueString = timeInRangeCalculation === undefined ? "--" :
    value >= 59.5
      ? round(
        value / 60,
        1,
      )
      : round(value)

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {valueString}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
